<header class="bg-white dark:bg-gray-900 px-4 lg:px-6 sticky top-0 z-20
          border-b border-gray-200 dark:border-gray-800 flex flex-col">

  <!-- Fila principal -->
  <div class="flex items-center gap-3 lg:gap-6 h-16 lg:h-20">

    <!-- Hamburger (solo mobile) -->
    <button type="button" (click)="menuToggle.emit()"
      class="lg:hidden p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-500 dark:text-gray-400 shrink-0">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>
      </svg>
    </button>

    <!-- Logo + título -->
    <div class="flex items-center gap-2 lg:gap-3 min-w-0 flex-1">
      <img src="/img/logo_iso.png" width="640" height="640" alt="Tramitex" class="h-8 lg:h-10 w-auto object-contain shrink-0" />
      <div class="min-w-0 flex-1">
        <h1 class="text-sm sm:text-base lg:text-xl font-bold text-gray-900 dark:text-white leading-tight line-clamp-2 sm:truncate" id="page-title">Gestoría de prueba SA. de CV.</h1>
        <p class="text-[11px] sm:text-xs text-gray-400 dark:text-gray-500 truncate" id="page-subtitle">Ing. Jesús David Hernández Sánchez</p>
      </div>
    </div>

    <!-- Selectores Cliente/Proyecto (solo xl+) -->
    <div class="hidden xl:flex items-center gap-3 flex-1 max-w-2xl">
      <div class="min-w-0 flex-1">
        <label class="text-[11px] font-semibold text-gray-400 mb-1 tracking-wider block dark:text-gray-500 uppercase">Cliente</label>
        <select class="select select-bordered w-full text-sm">
          <option selected>Constructora Azteca S.A.</option>
          <option>Inmobiliaria del Norte</option>
          <option>TechSoluciones MX</option>
          <option>Grupo Empresarial Alfa</option>
        </select>
      </div>
      <div class="min-w-0 flex-1">
        <label class="text-[11px] font-semibold text-gray-400 mb-1 tracking-wider block dark:text-gray-500 uppercase">Proyecto</label>
        <select class="select select-bordered w-full text-sm">
          <option selected>Licencia Construcción Lote 14</option>
          <option>Permiso Ambiental Zona Norte</option>
          <option>Registro Marca Comercial</option>
        </select>
      </div>
    </div>

    <!-- Acciones (notif + avatar con dropdown) -->
    <div class="flex items-center gap-2 lg:gap-3 shrink-0">

      <!-- Notificaciones -->
      <button type="button" title="Notificaciones" class="relative p-2 hover:bg-gray-100 dark:hover:bg-gray-700 transition rounded-xl">
        <svg class="w-5 h-5 text-gray-500 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path></svg>
        <span class="w-2 h-2 bg-red-500 rounded-full absolute top-1.5 right-1.5 animate-pulse"></span>
      </button>

      <!-- Avatar con dropdown -->
      <div class="relative">
        <button type="button" id="profile-btn"
          (click)="profileOpen.set(!profileOpen())"
          class="flex items-center gap-2 rounded-full focus:outline-none">
          <img alt="avatar" src="/img/default-avatar.png"
               class="object-cover ring-2 ring-gray-400 w-9 h-9 rounded-full" />
        </button>

        <!-- Overlay para cerrar al click fuera -->
        @if (profileOpen()) {
          <div class="fixed inset-0 z-40" (click)="profileOpen.set(false)"></div>
        }

        <!-- Dropdown panel -->
        @if (profileOpen()) {
          <div class="absolute right-0 top-full mt-2 w-56 z-50
                      bg-white dark:bg-gray-900 rounded-2xl shadow-xl border border-gray-100 dark:border-gray-800
                      animate-in fade-in slide-in-from-top-2 duration-150">

            <!-- Info usuario -->
            <div class="px-4 py-3 border-b border-gray-100 dark:border-gray-800">
              <div class="flex items-center gap-3">
                <img alt="avatar" src="/img/default-avatar.png"
                     class="object-cover ring-2 ring-gray-400 w-10 h-10 rounded-full shrink-0" />
                <div class="min-w-0">
                  <p class="text-sm font-semibold text-gray-800 dark:text-gray-100 truncate">Lic. Carlos Méndez</p>
                  <p class="text-xs text-gray-400 dark:text-gray-500 truncate">Gestor Senior</p>
                </div>
              </div>
            </div>

            <!-- Opciones -->
            <div class="p-1.5">
              <a routerLink="/perfil" (click)="profileOpen.set(false)"
                class="flex items-center gap-3 px-3 py-2 rounded-xl text-sm text-gray-700 dark:text-gray-300
                       hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors">
                <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0z"/>
                </svg>
                Perfil
              </a>
              <button type="button" (click)="logout()"
                class="w-full flex items-center gap-3 px-3 py-2 rounded-xl text-sm text-red-600 dark:text-red-400
                       hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
                </svg>
                Cerrar sesión
              </button>
            </div>

          </div>
        }
      </div>

    </div>


  </div>

  <!-- Fila de filtros (móvil y tablet — oculta en xl+) -->
  <div class="xl:hidden flex gap-2 items-center h-14 px-0 pb-1">
    <div class="flex-1 min-w-0">
      <label class="text-[10px] font-semibold text-gray-400 mb-0.5 tracking-wider block dark:text-gray-500 uppercase">Cliente</label>
      <select class="select select-bordered select-sm w-full text-xs">
        <option selected>Constructora Azteca S.A.</option>
        <option>Inmobiliaria del Norte</option>
        <option>TechSoluciones MX</option>
        <option>Grupo Empresarial Alfa</option>
      </select>
    </div>
    <div class="flex-1 min-w-0">
      <label class="text-[10px] font-semibold text-gray-400 mb-0.5 tracking-wider block dark:text-gray-500 uppercase">Proyecto</label>
      <select class="select select-bordered select-sm w-full text-xs">
        <option selected>Licencia Construcción Lote 14</option>
        <option>Permiso Ambiental Zona Norte</option>
        <option>Registro Marca Comercial</option>
      </select>
    </div>
  </div>

</header>
